import { render, staticRenderFns } from "./OrderDownloads.vue?vue&type=template&id=0dbb08a2&"
import script from "./OrderDownloads.vue?vue&type=script&lang=js&"
export * from "./OrderDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports